import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-container">
      <section className="about-header">
        <h1>About <span>Apco Lighting</span></h1>
        <p>
          At Apco Lighting, we revolutionize landscapes with innovative outdoor lighting solutions. 
          We specialize in design-driven, sustainable lighting for gardens, poles, and modern spaces.
        </p>
      </section>

      <section className="leadership-section">
        <h2>Meet Our Leadership</h2>
        <div className="leaders">
          <div className="leader-card">
            <img src="/images/Founders/PramodMishra.png" alt="Director" />
            <h3>Pramod Kumar</h3>
            <p className="title">Director</p>
            <p>"At Apco Lighting, we innovate with passion and deliver lighting that transforms environments."</p>
          </div>
          
          <div className="leader-card">
            <img src="/images/Founders/AshwinMishra.png" alt="CEO" />
            <h3>Ashwin Mishra</h3>
            <p className="title">CEO</p>
            <p>"We lead with vision—merging design and technology to brighten every space we touch."</p>
          </div>

          <div className="leader-card">
            <img src="/images/Founders/SatyamMishra.png" alt="BDO" />
            <h3>Satyam Mishra</h3>
            <p className="title">Business Development Officer</p>
            <p>"We believe in building relationships as strong as our lighting. Illuminating futures, not just spaces."</p>
          </div>
        </div>
      </section>

      <section className="mission-vision">
        <h2>Our Mission & Vision</h2>
        <div className="mv-cards">
          <div className="mv-card">
            <h3>Vision</h3>
            <p>To be a global leader in lighting, setting benchmarks in design, creativity, and reliability.</p>
          </div>
          <div className="mv-card">
            <h3>Mission</h3>
            <p>Deliver innovative, sustainable, and aesthetic lighting solutions that enrich lives.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
